export const PLATFORM_ANNONCEMENTS_GET_START =
  'PLATFORM_ANNONCEMENTS_GET_START';
export const PLATFORM_ANNONCEMENTS_GET_SUCCESS =
  'PLATFORM_ANNONCEMENTS_GET_SUCCESS';
